export default __webpack_public_path__ + "static/codam-9850ae22bc474bcbce8475b1138d0fba.png";